import React from "react";
import { useNavigate } from 'react-router-dom'
import { setToken, clearToken } from '../../utils/reducers/authSlice';
import { useDispatch, useSelector } from 'react-redux'

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = (e) =>{
    e.preventDefault();
    dispatch(clearToken());
    navigate("/login")
  }
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="/" role="button">
            <i className="fas fa-bars"></i>
          </a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <a href="index.html" className="nav-link">
            Visit our Auction Site 
          </a>
        </li>
      </ul>

      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto">
        {/* Messages Dropdown Menu */}
        
        {/* Notifications Dropdown Menu */}
        <li className="nav-item dropdown">
          <a className="nav-link" data-toggle="dropdown" href="/">
            <i className="far fa-user"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span className="dropdown-item dropdown-header">Hello Admin</span>
            <div className="dropdown-divider"></div>
            
            <div className="dropdown-divider"></div>
            <a href="/" className="dropdown-item">
              <i className="fas fa-user mr-2"></i>My Profile
            </a>
            <div className="dropdown-divider"></div>
            
            <div className="dropdown-divider"></div>
            <a onClick={handleLogout} className="dropdown-item dropdown-footer">
              Sign Out
            </a>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
